<template>
  <el-dialog :visible.sync="dialogVisible" :title="dialogTitle"
             :close-on-click-modal="false" @close="dialogClose" width="1500px">
    <div class="massLoss-list">
      <div class="content">
        <div class="tableContainer">
          <el-table v-loading="tableLoading" :data="tableData" style="width: 100%" border
                    :header-cell-style="headerCellStyle" >
            <el-table-column prop="zbId" label="本系统id" align="center" min-width="100px" />
            <el-table-column prop="jsdnm" label="浪潮系统id" align="center" min-width="100px" />
            <el-table-column prop="companyCode" label="公司code" align="center" min-width="100px" />
            <el-table-column prop="message" label="报错信息" align="center" min-width="100px"  show-overflow-tooltip/>
            <el-table-column prop="price" label="合计金额" align="center" min-width="100px" />
            <el-table-column prop="type" label="费用类型" align="center" min-width="100px" :formatter="typeFormat"/>
            <el-table-column prop="isSend" label="推送状态" align="center" min-width="100px">
              <template slot-scope="scope">
                {{scope.row.isSend === 0 ? '否' : '是'}}
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="推送时间" align="center" min-width="100px" />
          </el-table>
        </div>
        <div class="paginationContainer">
          <el-pagination
            background
            :page-sizes="[10, 20, 30, 40]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="getErrorSizeChange"
            @current-change="getErrorCurrentChange"
            :current-page.sync="page"
            :page-size="rows" />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import {
    getAccountCoDetail,
    getAccountCollectDetail,
    getAccountPageList,
    getError,
  } from '@/service/account';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'pushError',
    data() {
      return {
        dialogVisible: false,
        dialogTitle: '推送报错',
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        page: 1,
        rows: 10,
        total: 0,
        params:{},
      }
    },
    methods: {
      dialogOpen(id) {
        this.dialogVisible = true
        if(id)this.getErrorTableData(id)
        this.params = {
          page: this.page,
          rows: this.rows,
          id: id
        }
      },
     async getErrorTableData(id) {
       this.tableLoading = true
       const {
         status,
         message,
         data
       } = await getError(id,this.page, this.rows)
       this.tableLoading = false
       if(status !== null) return this.$message.warning(message);
       this.tableData = data.records;
       this.total = data.total;
      },
      getErrorSizeChange(row) {
        this.rows = row;
        this.page = 1;
        this.getErrorTableData( this.params.id,this.page,this.rows);
      },
      getErrorCurrentChange(page) {
        this.page = page;
        this.getErrorTableData( this.params.id,this.page,this.rows);
      },
      typeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '收入';
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装船费';
          case 4:
            return '卸船费';
          case 5:
            return '过驳费';
          case 6:
            return '转船费';
          case 7:
            return '堆存费';
          case 8:
            return '提车费';
          case 9:
            return '伪支出';
        }
      },
      dialogClose(){
        this.dialogVisible = false
      }
    }
  };
</script>

<style lang="scss">
  .massLoss-list {
    //width:100%;
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }
            }
          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }
    }
  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .input-show-wrap input {
    color: red !important;
  }
</style>
